module.exports = __webpack_public_path__ + "media/images/country_flags/il-33e32c30f8e36bf625e51db907d86c15.png";